import { Box, Typography } from "@mui/material";
import cardStyles from "../dashboard-active-card/style.module.css";

/**
 * Same visual as the Active Students/Courses/Teachers cards on the dashboard,
 * with the title/value/icon supplied by the caller.
 */
export const StatCard = ({ title, value, icon }) => {
  return (
    <Box className={cardStyles.totalJobsContainer}>
      <Box className={cardStyles.left_box}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="h4">{value}</Typography>
      </Box>
      <Box className={cardStyles.imageContainer}>{icon}</Box>
    </Box>
  );
};

export default StatCard;
